import React from 'react';
import { ResponsiveImage } from './ResponsiveImage';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  priority?: boolean; // For above-the-fold images (LCP optimization)
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '', priority = false }) => {
  const sizeConfig = {
    sm: { width: 32, height: 32, className: 'h-8 w-8' },
    md: { width: 48, height: 48, className: 'h-12 w-12' },
    lg: { width: 64, height: 64, className: 'h-16 w-16' },
    xl: { width: 96, height: 96, className: 'h-24 w-24' }
  };

  const logoSources = {
    sm: '/logo-sm.webp',
    md: '/logo-md.webp',
    lg: '/logo-lg.webp',
    xl: '/logo-xl.webp'
  };

  const config = sizeConfig[size];

  return (
    <ResponsiveImage 
      src={logoSources[size]}
      alt="CruzaSmart Logo" 
      className={`${config.className} object-contain ${className}`}
      width={config.width}
      height={config.height}
      priority={priority}
      sizes={`${config.width}px`}
    />
  );
};

export default Logo;
